const callToAction = require('../../json/callToAction.json');
const languageJson = require('../../json/language.json');
import { saveOptLog } from '@/api/google/youtube';

export const languages = Object.keys(languageJson).map((key) => {
  return { key, value: languageJson[key] };
});
export const callToActions = callToAction;

/**
 * 校验函数
 */
// 校验素材重复
const checkResourceDuplicate = (value) => {
  const resourceNames = value.map((item) => item.resourceName || item.videoId);
  return new Set(resourceNames).size !== resourceNames.length;
};
// 校验图片素材
export const validatorMedia = (rule, value, callback) => {
  if (!value || !value.length) {
    return callback(new Error('请上传图片素材'));
  }
  if (value.length > 20) {
    return callback(new Error('最多上传20张图片'));
  }
  const status = Array.from(new Set(value.map((item) => item.status)));
  if (!(status.length === 1 && status.includes('success'))) {
    return callback(new Error('存在上传中或上传失败的素材'));
  }
  if (checkResourceDuplicate(value)) {
    return callback(new Error('存在重复素材，请检查'));
  }
  callback();
};
// 校验视频素材
export const validatorVideo = (rule, value, callback) => {
  if (!value || !value.length) {
    return callback(new Error('请上传视频素材'));
  }
  if (value.length > 5) {
    return callback(new Error('最多上传5个视频'));
  }
  const status = Array.from(new Set(value.map((item) => item.status)));
  if (!(status.length === 1 && status.includes('succeeded'))) {
    return callback(new Error('存在上传中或上传失败的素材'));
  }
  if (checkResourceDuplicate(value)) {
    return callback(new Error('存在重复素材，请检查'));
  }
  callback();
};

// 校验徽标
export const validatorCollVideoMedia = (rule, value, callback) => {
  if (!value || !value.length) {
    return callback(new Error('请上传徽标'));
  }
  if (value.length > 1) {
    return callback(new Error('最多上传1张缩略图'));
  }
  if (checkResourceDuplicate(value)) {
    return callback(new Error('存在重复素材，请检查'));
  }
  callback();
};
export const validatorCollImgMedia = (rule, value, callback) => {
  if (!value || !value.length) {
    return callback(new Error('请上传徽标'));
  }
  if (value.length < 1 || value.length > 5) {
    return callback(new Error('请上传至少1张至多5张缩略图'));
  }
  if (checkResourceDuplicate(value)) {
    return callback(new Error('存在重复素材，请检查'));
  }
  callback();
};
const SpecialWords = ['*', '！', '㎡', 'F.L.O.W.E.R.S', '##'];

// 计算文本字节数
export const getByteLength = (str) => {
  if (!str) return 0;
  let byteLength = 0;
  // 使用 for...of 来确保正确遍历可能由代理对组成的字符
  for (const char of str) {
    const code = char.codePointAt(0);
    if (code <= 0x7f) {
      // ASCII 字符
      byteLength += 1;
    } else if (/\p{Emoji}/u.test(char)) {
      // Emoji 字符
      byteLength += 4;
    } else if (code >= 0x0e00 && code <= 0x0e7f) {
      // 泰文字符
      byteLength += 1;
    } else if ((code >= 0xa0 && code <= 0xff) || (code >= 0x100 && code <= 0x24f)) {
      // ISO-8859-2中欧字符集（覆盖捷克语等，单字节）
      byteLength += 1;
    } else if (code >= 0x0600 && code <= 0x06ff) {
      // 阿拉伯语字符，按字符数计算
      byteLength += 1;
    } else if (code >= 0x1f000 && code <= 0x1ffff) {
      // Emoji（Unicode补充平面，4字节）
      byteLength += 4;
    } else {
      // 其它非 ASCII 字符
      byteLength += 2;
    }
  }
  return byteLength;
};

// const getByteLength = (str) => {
//   if (!str) return 0;
//   let byteLength = 0;

//   for (const char of str) {
//     const code = char.codePointAt(0);

//     // 1. ASCII字符（0-127）：1字节
//     if (code <= 0x7f) {
//       byteLength += 1;
//     }
//     // 2. ISO-8859-2中欧字符集（覆盖捷克语等，单字节）
//     // 包含：0x00A0-0x00FF（扩展Latin）、0x0100-0x024F（中欧特殊字符）
//     else if ((code >= 0xa0 && code <= 0xff) || (code >= 0x100 && code <= 0x24f)) {
//       byteLength += 1;
//     }
//     // 3. Emoji（Unicode补充平面，4字节）
//     else if (code >= 0x1f000 && code <= 0x1ffff) {
//       byteLength += 4;
//     }
//     // 4. 其他多字节字符（如中日韩等，2字节）
//     else {
//       byteLength += 2;
//     }
//   }

//   return byteLength;
// };
// 校验标题
export const validateWord = (type, size, rule, value, callback) => {
  if (!value || !value.length || !value.filter((v) => v).length) {
    return callback(new Error(`请填写${type}`));
  }
  //   if (value.filter((v) => !v).length) {
  //     return callback(new Error(`${type}不能为空`));
  //   }
  if (value.map((v) => v).length > 5) {
    return callback(new Error(`最多填写5条${type}`));
  }
  console.log(new Set(value.filter((v) => v)).size);
  if (new Set(value.filter((v) => v)).size !== value.filter((v) => v).length) {
    return callback(new Error(`${type}不能重复`));
  }
  if (value.filter((v) => SpecialWords.some((item) => v && v.indexOf(item) > -1)).length) {
    return callback(new Error(`${type}包含特殊字符`));
  }
  if (value.filter((v) => getByteLength(v) > size).length) {
    return callback(new Error(`${type}长度超过${size}字节`));
  }
  callback();
};

// 图片视频通用校验
const baseRules = {
  callToAction: [
    {
      required: false,
      message: '请选择行动号召',
    },
  ],

  headlines: [
    {
      required: true,
      validator: (rule, value, callback) => validateWord('标题', 40, rule, value, callback),
    },
  ],
  descriptions: [
    {
      required: true,
      validator: (rule, value, callback) => validateWord('描述', 90, rule, value, callback),
    },
  ],
  businessName: [
    {
      required: true,
      validator: (rule, value, callback) => {
        if (!value) return callback(new Error(`请输入商家名称`));
        if (getByteLength(value) > 25) {
          return callback(new Error(`商家名称长度不能超过25字节`));
        }
        callback();
      },
      trigger: 'change',
    },
  ],
};

// 图片视频校验
export const imgRules = {
  ...baseRules,
  logoImages: {
    required: true,
    validator: validatorCollImgMedia,
  },
  multiImages: [
    {
      validator: validatorMedia,
      required: true,
    },
  ],
  callToAction: [
    { required: true },
    {
      validator: (rule, value, callback) => {
        console.log(value);
        if (value && !value.keyword && value.key) {
          return callback(new Error('请选择行动号召'));
        } else {
          callback();
        }
      },
      trigger: 'change',
    },
  ],
};
// 图片视频校验
export const videoRules = {
  ...baseRules,
  logoImages: {
    required: true,
    validator: validatorCollVideoMedia,
  },
  videoLongHeadlines: [
    {
      required: true,
      validator: (rule, value, callback) => validateWord('视频长标题', 90, rule, value, callback),
    },
  ],
  videoAssets: [
    {
      validator: validatorVideo,
      required: true,
      trigger: 'change',
    },
  ],
};

// 保存优化师日志

export const getOptLogId = async (mediaMsg) => {
  try {
    const optRes = await saveOptLog({
      ...mediaMsg,
    });
    return optRes.data.id;
  } catch {
    return null;
  }
};

// 素材名称
export const formatterName = (str, newmd5, userInfo) => {
  const lastIndex = str.lastIndexOf('.');
  let strList = [];
  // 根据最后一个点进行分割
  // 存在最后一个点
  if (lastIndex !== -1) {
    strList = [str.slice(0, lastIndex), str.slice(lastIndex + 1)];
  } else {
    strList = [str, ''];
  }
  if (strList.length === 2 && newmd5) {
    const nameSplitList = splitStringByMultipleDelimiters(strList[0]);
    // 符合规则
    if (nameSplitList.length === 3) {
      const isNumeric = (numStr) => /^\d+$/.test(numStr);
      if (isNumeric(nameSplitList[0])) {
        return `${nameSplitList[0]}#${nameSplitList[1]}#${newmd5}`;
      } else {
        return `${userInfo.id}#${userInfo.name}#${newmd5}`;
      }
    } else if (nameSplitList.length > 3) {
      let list = nameSplitList.slice(0, 2);
      return list.join('#') + '#' + newmd5;
    } else {
      return `${userInfo.id}#${userInfo.name}#${newmd5}`;
    }
  } else {
    return str;
  }
};
// 校验素材名字
const splitStringByMultipleDelimiters = (str) => {
  // 使用正则表达式匹配所有 -、* 或 # 字符，并启用全局标志
  const delimiters = /[-*#]/g;
  // 使用字符串的 split 方法，但传入一个正则表达式作为分隔符
  // 注意：split 方法会将分隔符本身从结果数组中排除
  return str.split(delimiters);
};
